import React from 'react';
import PropTypes from 'prop-types';
import IconRestriction from '../Icons/IconRestriction';
import IconException from '../Icons/IconException';
import IconNotes from '../Icons/IconNotes';
import IconPerson from '../Icons/IconPerson';
import IconSortDown from '../Icons/IconSortDown';
import { TextMedium } from '../../common/text';
import { RowItem, ChartHeader, RowHeaderBase } from 'lib/components/_charts/ChartRowAndHeader.styles';
import IconSortUp from 'lib/components/Icons/IconSortUp';

const getSortHandler = (sortKey, handleSort) => (evt) => handleSort(sortKey);

const getSortItem = (sort, handleSort) => ({ children, sortKey, ...rest }) => (
    <RowItem onClick={getSortHandler(sortKey, handleSort)} {...rest}>
        {children}
        {sort.sortKey === sortKey && (sort.ascending ? <IconSortDown /> : <IconSortUp />)}
    </RowItem>
);

export const PerformanceChartHeader = ({ width, chartWidth, sort, handleSort, hideDivider }) => {
    const WithSortIcon = getSortItem(sort, handleSort);

    return (
        <ChartHeader chartWidth={chartWidth}>
            <RowHeaderBase width={width} hideDivider={hideDivider}>
                <WithSortIcon sortKey="id" width="100">
                    <TextMedium>NAME</TextMedium>
                </WithSortIcon>
                <WithSortIcon sortKey="generation" width="100">
                    <TextMedium>GENERATION</TextMedium>
                </WithSortIcon>
                <WithSortIcon sortKey="average" width="100">
                    <TextMedium>% PARK AVG</TextMedium>
                </WithSortIcon>
                <WithSortIcon sortKey="persons" flex="1">
                    <IconPerson size={13} white />
                </WithSortIcon>
                <WithSortIcon sortKey="notes" flex="1">
                    <IconNotes size={13} />
                </WithSortIcon>
                <WithSortIcon sortKey="restrictions" flex="1">
                    <IconRestriction size={13} />
                </WithSortIcon>
                <WithSortIcon sortKey="alarms" flex="1">
                    <IconException size={13} />
                </WithSortIcon>
            </RowHeaderBase>
        </ChartHeader>
    );
};

PerformanceChartHeader.displayName = 'PerformanceChartHeader';

PerformanceChartHeader.propTypes = {
    width: PropTypes.number,

    hideDivider: PropTypes.bool,
    sort: PropTypes.shape({
        sortKey: PropTypes.string.isRequired,
        ascending: PropTypes.bool.isRequired,
    }).isRequired,
};

PerformanceChartHeader.defaultProps = {
    width: 400,
    sort: { sortKey: 'average', ascending: false },
};
